"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AI_CONVERSATION_MESSAGE_ROLES () {
        return AI_CONVERSATION_MESSAGE_ROLES;
    },
    get AI_CONVERSATION_TITLE_SOURCES () {
        return AI_CONVERSATION_TITLE_SOURCES;
    },
    get AiConversationMessageModel () {
        return AiConversationMessageModel;
    },
    get AiConversationMessageRole () {
        return AiConversationMessageRole;
    },
    get AiConversationModel () {
        return AiConversationModel;
    },
    get AiConversationSourceSchema () {
        return AiConversationSourceSchema;
    },
    get AiConversationSuggestionCardSchema () {
        return AiConversationSuggestionCardSchema;
    },
    get AiConversationSuggestionsSchema () {
        return AiConversationSuggestionsSchema;
    },
    get AiConversationTitleSource () {
        return AiConversationTitleSource;
    },
    get MAX_AI_CONVERSATION_FALLBACK_TITLE_LENGTH () {
        return MAX_AI_CONVERSATION_FALLBACK_TITLE_LENGTH;
    },
    get MAX_AI_CONVERSATION_PREVIEW_LENGTH () {
        return MAX_AI_CONVERSATION_PREVIEW_LENGTH;
    },
    get MAX_AI_CONVERSATION_TITLE_LENGTH () {
        return MAX_AI_CONVERSATION_TITLE_LENGTH;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const AiConversationSourceSchema = _zod.z.object({
    s3_file_id: _zod.z.string(),
    filename: _zod.z.string(),
    chunk_count: _zod.z.number(),
    relevance_score: _zod.z.number()
});
const AI_CONVERSATION_TITLE_SOURCES = [
    "prompt",
    "generated"
];
const AiConversationTitleSource = _zod.z.enum(AI_CONVERSATION_TITLE_SOURCES);
const AiConversationSuggestionCardSchema = _zod.z.record(_zod.z.string(), _zod.z.unknown());
const AiConversationSuggestionsSchema = _zod.z.object({
    /** `AskSSEGoalSuggestion[]` — goal-agent "Suggested Goals" cards. */ goals: _zod.z.array(AiConversationSuggestionCardSchema).optional(),
    /** `AskSSEFormSuggestion[]` — form-agent "Suggested Form" cards. */ forms: _zod.z.array(AiConversationSuggestionCardSchema).optional(),
    /** `AskSSEFormQuestionSuggestionWithId[]` — form-builder "Suggested Questions" cards. */ form_questions: _zod.z.array(AiConversationSuggestionCardSchema).optional(),
    /** `AskSSEGoalImprovement[]` — goal-quality-coach "Suggested Improvements" cards. */ goal_improvements: _zod.z.array(AiConversationSuggestionCardSchema).optional(),
    /** `AskSSEFormImprovement[]` — form-building-coach "Suggested Improvements" cards. */ form_improvements: _zod.z.array(AiConversationSuggestionCardSchema).optional(),
    /** `AskSSEResponseImprovement[]` — form-authoring-coach "Suggested Improvements" cards. */ response_improvements: _zod.z.array(AiConversationSuggestionCardSchema).optional()
});
const AI_CONVERSATION_MESSAGE_ROLES = [
    "user",
    "assistant"
];
const AiConversationMessageRole = _zod.z.enum(AI_CONVERSATION_MESSAGE_ROLES);
const MAX_AI_CONVERSATION_TITLE_LENGTH = 120;
const MAX_AI_CONVERSATION_PREVIEW_LENGTH = 280;
const MAX_AI_CONVERSATION_FALLBACK_TITLE_LENGTH = 40;
const AiConversationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    /** Author. Conversations are private to this user — never listed for anyone else, admins included. */ user_id: _zod.z.instanceof(_bson.ObjectId),
    title: _zod.z.string().max(MAX_AI_CONVERSATION_TITLE_LENGTH),
    title_source: AiConversationTitleSource,
    /**
	 * The first user message, truncated. Denormalized onto the parent so a list
	 * row can show what was asked without reading the transcript. Search does
	 * not match it: the row renders the title alone, so a preview-only hit had
	 * no visible reason to be in the results.
	 */ preview: _zod.z.string().max(MAX_AI_CONVERSATION_PREVIEW_LENGTH),
    message_count: _zod.z.number(),
    /** Every agent that has answered in this thread, for support triage. */ agents: _zod.z.array(_zod.z.string()),
    /** The client's tracing session id for the turn that created this conversation, for llm_log correlation. */ session_id: _zod.z.string().optional(),
    created_at: _utilsisomorphic.transformDate,
    updated_at: _utilsisomorphic.transformDate
});
const AiConversationMessageModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    conversation_id: _zod.z.instanceof(_bson.ObjectId),
    /** 0-based position in the thread. Unique per conversation. */ seq: _zod.z.number(),
    role: AiConversationMessageRole,
    content: _zod.z.string(),
    /** Assistant turns only. */ sources: _zod.z.array(AiConversationSourceSchema).optional(),
    /** Assistant turns only. Absent when the turn produced no cards. */ suggestions: AiConversationSuggestionsSchema.optional(),
    /** Which agent produced this turn, from the router's classification. */ agent: _zod.z.string().optional(),
    confidence: _zod.z.string().optional(),
    created_at: _utilsisomorphic.transformDate
});
